<template>
  <div class="register absolute">
        {{ message }}
  </div>
</template>
<script> 

const BACK_URL = "login_back_url"; 
export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      message : "出现异常了！！！",
      type: "login"
    };
  },
  methods: {
    
  }
};
</script>
